export const RADIUS = {
  globe: 1,
  coastline: 1.012,
  timezone: 1.013,
  dot: 1.02,
  backfaceMask: 0.99,
};

export const MAP_WIDTH = 2;
export const MAP_HEIGHT = 1;
export const MAP_FILL = 0.9;

export const POLE_EDGE_CLEARANCE = 0.025;

export const DOT_PX = 4;

export const FLAT_Z = {
  timezone: 0.0015,
  dot: 0.03,
};

export const COASTLINE_COLOR = '#ffffff';
export const COASTLINE_OPACITY = 0.4;
export const ZONE_OPACITY = 0.9;
